import * as owasp from 'owasp-password-strength-test';

export const DEFAULT_MIN_LENGTH_PASSWORD = 12;
export const DEFAULT_MIN_JA_LENGTH_PASSWORD = 20;
export const MAX_INPUT_FIELD_LENGTH = 254;

// Not 100% RFC 5322 compliant, but should match any email addresses in use.
// Source: http://www.regular-expressions.info/email.html
const EMAIL_REGEX = new RegExp(
  "^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$",
  'i'
);

// Regex checks applied by accounts
const ACCOUNTS_SPECIAL_CHARS = /[\!"#\$%&'\(\)\*+,-\.\/:;<=>\?@\{\}\^\|\\\[\]_]/;
const ACCOUNTS_GENERAL_REGEX = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)./;

export function validateEmail(input: string): boolean {
  return EMAIL_REGEX.test(input);
}

export function validatePassword(
  input: string,
  options: { minLength: number } = { minLength: DEFAULT_MIN_LENGTH_PASSWORD }
): owasp.TestResult {
  owasp.config({
    minLength: options.minLength
  });
  owasp.tests.required.push((password) => {
    if (!ACCOUNTS_GENERAL_REGEX.test(password)) {
      return 'Password must contain one uppercase letter, one lowercase letter, one special character and one digit';
    }
  });
  owasp.tests.required.push((password) => {
    if (!ACCOUNTS_SPECIAL_CHARS.test(password)) {
      return 'Password must contain one special character';
    }
  });

  return owasp.test(input);
}

export function validateLength(input: string): boolean {
  return input.length < MAX_INPUT_FIELD_LENGTH;
}
